import {Component} from '@angular/core';
import {formatCurrency, formatNumber} from '@angular/common';
import {MatDialog} from '@angular/material/dialog';

export interface LinkId {
  id: string;
  description: string;
  amount: number;
}

@Component({
             selector: 'app-detail-table',
             templateUrl: './link-id-table.component.html',
             styleUrls: ['../../detail-screen/detail-screen.component.css'],
           })
export class LinkIdTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: LinkId[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor(public dialog: MatDialog) {
    this.tableColumns = [];
    this.tableData = [];
  }
  getAmountInPercentage(value) {
    if (this.restrictedData) {
      return value;
    } else {
      if (value || value === 0) {
        value = formatNumber(value, 'en-US', '1.3-3');
      } else {
        value = this.emptyValuePlaceholder;
      }
      return value;
    }
  }
}
